import { FC } from "react";

interface Props {
  text: string;
  highlight: string;
}

const defaultProps = {
  text: "",
  highlight: "",
};

export const Highlighted: FC<Props & typeof defaultProps> = ({
  text,
  highlight,
}) => {
  if (!highlight.trim()) {
    return <span>{text}</span>;
  }
  const regex = /`(${highlight})`/gi;
  const parts = text.split(regex);

  return (
    <span>
      {parts.filter(String).map((part) => {
        return regex.test(part) ? (
          <span key={part}>{part}</span>
        ) : (
          <strong key={part}>{part}</strong>
        );
      })}
    </span>
  );
};

Highlighted.defaultProps = defaultProps;
